// extracted by mini-css-extract-plugin
export default {"footer":"FooterSection_footer__-FRQh","footerSection":"FooterSection_footerSection__LBWHj","footerSectionLink":"FooterSection_footerSectionLink__zX6Mq"};